import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ToastService {
    private controller: HTMLAnjToastControllerElement;
    private _dismissed$: Subject<CustomEvent> = new Subject();

    get dismissed$(): Observable<CustomEvent> {
        return this._dismissed$.asObservable();
    }

    public static createController(): HTMLAnjToastControllerElement {
        const controller = document.createElement('anj-toast-controller');
        document.body.appendChild(controller);
        return controller as HTMLAnjToastControllerElement;
    }

    public async dismissAll(): Promise<void> {
        const controller = await this.getController();
        return controller.dismissAll();
    }

    public async error(message: string, header?: string): Promise<HTMLAnjToastElement> {
        const controller = await this.getController();
        return controller.error(message, header);
    }

    public async message(message: string, header?: string): Promise<HTMLAnjToastElement> {
        const controller = await this.getController();
        return controller.message(message, header);
    }

    public async success(message: string, header?: string): Promise<HTMLAnjToastElement> {
        const controller = await this.getController();
        return controller.success(message, header);
    }

    public async warn(message: string, header?: string): Promise<HTMLAnjToastElement> {
        const controller = await this.getController();
        return controller.warn(message, header);
    }

    public async getController(): Promise<HTMLAnjToastControllerElement> {
        return this.controller || this.findController();
    }

    private findController(): Promise<HTMLAnjToastControllerElement> {
        const controller = this.findOrCreate(document.querySelector('anj-toast-controller'));
        controller.addEventListener('anjToastDidDismiss', this.onToastDidDismiss.bind(this));
        this.controller = controller;
        return controller.componentOnReady();
    }

    private onToastDidDismiss(event: CustomEvent) {
        this._dismissed$.next(event);
    }

    private findOrCreate(control: HTMLAnjToastControllerElement | null) {
         return control || ToastService.createController();
    }
}
